import axios from "axios";

const getFeaturedItems = tag =>
  axios.get(`${process.env.REACT_APP_BASE_URL}/api/learn/featured/${tag}/3`);

const getGeneralItems = (tag, keyword) =>
  axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/learn/general/${tag}/${keyword}`
  );

const getSuggestions = (tag, keyword) =>
  axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/learn/suggest/${tag}/${keyword}`
  );

export { getFeaturedItems, getGeneralItems, getSuggestions };
